  $(() => {
      $('label[class="vto-color"]').on('click', function(e) {
          e.preventDefault();

          YMK.sku = $(this).closest("div").attr('data-sku');
          YMK.productId = $(this).closest("div").attr('data-id');
          YMK.variantId = $(this).closest("div").attr('data-variant-id');
    	  var title = $("div[data-sku='"+YMK.sku+"']").attr('data-title');
          var review = document.querySelector("div[data-sku='"+YMK.sku+"'] div[data-oke-star-rating]").innerHTML;
    
          console.log('sku', YMK.sku);
          console.log('productId', YMK.productId);
          console.log('variantId', YMK.variantId);

          YMK.applyMakeupBySku(YMK.sku);
    	
		  $('.option_title')[0].innerHTML = '<div style="text-align: right; margin: auto 0px auto 0px; padding-right: 10px; font-size: 1.4em">' + title + '</div>' + review;
          $("#product_form_").find(".add_to_cart").css("display", "")
      });
  });